export const SupportTicketStatic = {
  dialogHeader: "Report an issue",
  FORM_DATA: {
    fields: [
      {
        name: "title",
        label: "Title",
        type: "text",
        placeholder: "Enter title",
        isRequired: true,
      },
      {
        name: "experiment_link",
        label: "Experiment Link",
        type: "text",
        placeholder: "Enter experiment link",
        isRequired: false,
      },
      {
        name: "description",
        label: "Description",
        type: "textarea",
        placeholder: "Enter description",
        isRequired: true,
      },
      {
        name: "steps_to_reproduce",
        label: "Steps to Reproduce",
        type: "textarea",
        placeholder: " Enter steps",
        isRequired: false,
      },
      {
        name: "impact_level",
        label: "Impact Level",
        type: "btn-select",
        placeholder: "",
        isRequired: true,
      },
      {
        name: "attachments",
        label: "Attachments",
        type: "file-upload",
        placeholder: "",
        isRequired: false,
      },
    ],
  },
  fileUploadContent: {
    placeholderText: "Drag & drop your files to upload",
  },
};
